<template>
  <v-layout>
    <v-flex class="margin">
      <loading :isLoading="isLoading" />
      <snackbar />
      <!-- mobile -->
      <div v-if="mobileView" id="e3" style="max-width: 800px; margin: auto" class="grey lighten-3">
        <v-card class="v-text-field-title">
          <v-toolbar color="#216AA9" dark>
            <v-toolbar-title>ผู้ใช้งานทั่วไป</v-toolbar-title>
          </v-toolbar>

          <v-container fluid grid-list-lg>
            <v-layout>
              <v-flex md9>
                <span class="texefild-mobile">ค้นหาโดยข้อความ : </span>
              </v-flex>
            </v-layout>
            <v-layout>
              <v-flex xs12 align-center py-3 v-if="mobileView">
                <v-text-field color="#0f4898" solo light label="search" hide-details v-model="searchAdmin"
                  append-icon="search" style="width: 90%; margin-left: 20px; margin-right: 20px">
                </v-text-field>
              </v-flex>
            </v-layout>

            <!-- add admin dialog -->
            <v-dialog v-model="dialog" max-width="500px">
              <template v-slot:activator="{ on }">
                <v-btn outline fab color="#0f4898" dark v-on="on" small>
                  <v-icon dark>mdi-account-plus</v-icon>
                </v-btn>
              </template>
              <v-card>
                <v-card-title>
                  <span class="headline" style="color: #0f4898;"><strong>Add User</strong></span>
                </v-card-title>

                <v-card-text>
                  <v-container grid-list-md>
                    <v-layout wrap>
                      <v-flex xs12>
                        <v-text-field ref="addmail" prepend-icon="mdi-email" v-model="addMail" label="E-mail"
                          color="#0f4898" :rules="[() => !!addMail || 'This field is required']"
                          required></v-text-field>
                      </v-flex>
                      <v-select ref="addmerchant" :items="merchantStore" label="Merchant" prepend-icon="mdi-store"
                        v-model="addMerchant" outlined color="#0f4898" item-text="merchant_name"
                        item-value="merchant_id" multiple></v-select>
                    </v-layout>
                  </v-container>
                </v-card-text>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn @click="close"
                    style="border-radius: 5px; border: 1px solid #FC3A3A; background-color: transparent; color: #FC3A3A;">
                    Cancel</v-btn>
                  <v-btn @click="save"
                    style="border-radius: 5px; border: 1px solid #51D245; background-color: transparent; color: #51D245;">
                    Save</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>

            <!-- edit dialog -->
            <v-dialog v-model="dialog2" max-width="500px">
              <v-card>
                <v-card-title>
                  <span class="headline" style="color: #0f4898;"><strong>Edit User</strong></span>
                </v-card-title>


                <v-card-text>
                  <v-container grid-list-md>
                    <v-layout wrap>
                      <v-flex xs12>
                        <v-text-field ref="editMail" prepend-icon="mdi-email" v-model="newEmail" label="E-mail"
                          color="#0f4898"></v-text-field>
                      </v-flex>

                      <v-select ref="editMerchant" :items="merchantStore" label="Merchant" prepend-icon="mdi-store"
                        v-model="editMerchant" outlined color="#0f4898" item-text="merchant_name"
                        item-value="merchant_id" multiple></v-select>
                    </v-layout>
                  </v-container>
                </v-card-text>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn @click="dialog2 = false"
                    style="border-radius: 5px; border: 1px solid #FC3A3A; background-color: transparent; color: #FC3A3A;">
                    Cancel</v-btn>
                  <v-btn @click="edit"
                    style="border-radius: 5px; border: 1px solid #51D245; background-color: transparent; color: #51D245;">
                    Save</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
            <v-dialog v-model="dialogConfirm" persistent max-width="500">
              <v-card>
                <v-card-title class="headline" style="color: #0f4898;"><strong>Delete User</strong></v-card-title>
                <v-card-text>Are you sure you want to delete this user?</v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn @click="dialogConfirm = false"
                    style="border-radius: 5px; border: 1px solid #000; background-color: transparent; color: #000;">
                    No</v-btn>
                  <v-btn @click="deleteItem"
                    style="border-radius: 5px; border: 1px solid #1976d2; background-color: transparent; color: #1976d2;">
                    OK</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
            <v-data-table :headers="headers" :items="userList" class="elevation-1" :search="searchAdmin"
              disable-initial-sort id="mytable">
              <template v-slot:items="props">
                <td class="text-left" style="font-size: 13px">
                  {{ props.item.email || '-' }}
                </td>
                <td class="text-xs-left" style="font-size: 13px">
                  {{ getMerchantNames(props.item.merchants) || '-' }}
                </td>
                <td class="justify-center layout px-0">
                  <v-icon small color="#0f4898" class="mr-2" @click="editItem(props.item.email, props.item.merchants)">
                    edit
                  </v-icon>
                  <v-icon small color="red" @click="dialogDel(props.item.email)">
                    delete
                  </v-icon>
                </td>
              </template>
            </v-data-table>
          </v-container>
        </v-card>
      </div>


      <!-- web -->
      <div v-if="!mobileView" id="e3" style="max-width: 1500px; margin: auto" class="grey lighten-3">
        <v-card class="v-text-field-title">
          <v-toolbar color="#216AA9" dark>
            <v-toolbar-title>ผู้ใช้งานทั่วไป</v-toolbar-title>
          </v-toolbar>

          <v-container fluid grid-list-lg>
            <!-- add admin dialog -->
            <v-container fluid>
              <!-- Layout หลัก -->
              <v-layout justify-space-between align-center>
                <!-- ปุ่มเพิ่มร้านค้าอยู่ซ้าย -->
                <v-flex shrink>
                  <v-dialog v-model="dialog" max-width="500px">
                    <template v-slot:activator="{ on }">
                      <v-btn outline fab color="#0f4898" dark v-on="on" small
                        style="margin-bottom: -10px; margin-left: -10px;">
                        <v-icon dark>mdi-account-plus</v-icon>
                      </v-btn>
                    </template>
                    <v-card>
                      <v-card-title>
                        <span class="headline" style="color: #0f4898;"><strong>Add User</strong></span>
                      </v-card-title>

                      <v-card-text>
                        <v-container grid-list-md>
                          <v-layout wrap>
                            <v-flex xs12>
                              <v-text-field ref="addmail" prepend-icon="mdi-email" v-model="addMail" label="E-mail"
                                color="#0f4898" :rules="[() => !!addMail || 'This field is required']"
                                required></v-text-field>
                            </v-flex>
                            <v-select ref="addmerchant" :items="merchantStore" label="Merchant" prepend-icon="mdi-store"
                              v-model="addMerchant" outlined color="#0f4898" item-text="merchant_name"
                              item-value="merchant_id" multiple></v-select>
                          </v-layout>
                        </v-container>
                      </v-card-text>

                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn @click="close"
                          style="border-radius: 5px; border: 1px solid #FC3A3A; background-color: transparent; color: #FC3A3A;">
                          Cancel
                        </v-btn>
                        <v-btn @click="save"
                          style="border-radius: 5px; border: 1px solid #51D245; background-color: transparent; color: #51D245;">
                          Save
                        </v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                </v-flex>

                <!-- ค้นหาอยู่ขวา -->
                <v-layout justify-end align-center>
                  <!-- ข้อความชิดขวา -->
                  <span class="texefild-mobile" style="margin-right: 8px;">ค้นหาโดยข้อความ :</span>

                  <!-- ช่องค้นหาชิดขวา -->
                  <v-flex md3>
                    <v-text-field color="#0f4898" solo light label="search" hide-details v-model="searchAdmin"
                      append-icon="search"></v-text-field>
                  </v-flex>
                </v-layout>
              </v-layout>
            </v-container>

            <!-- edit dialog -->
            <v-dialog v-model="dialog2" max-width="500px">
              <v-card>
                <v-card-title>
                  <span class="headline" style="color: #0f4898;"><strong>Edit User</strong></span>
                </v-card-title>


                <v-card-text>
                  <v-container grid-list-md>
                    <v-layout wrap>
                      <v-flex xs12>
                        <v-text-field ref="editMail" prepend-icon="mdi-email" v-model="newEmail" label="E-mail"
                          color="#0f4898"></v-text-field>
                      </v-flex>

                      <v-select ref="editMerchant" :items="merchantStore" label="Merchant" prepend-icon="mdi-store"
                        v-model="editMerchant" outlined color="#0f4898" item-text="merchant_name"
                        item-value="merchant_id" multiple></v-select>
                    </v-layout>
                  </v-container>
                </v-card-text>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn @click="dialog2 = false"
                    style="border-radius: 5px; border: 1px solid #FC3A3A; background-color: transparent; color: #FC3A3A;">
                    Cancel</v-btn>
                  <v-btn @click="edit"
                    style="border-radius: 5px; border: 1px solid #51D245; background-color: transparent; color: #51D245;">
                    Save</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
            <v-dialog v-model="dialogConfirm" persistent max-width="500">
              <v-card>
                <v-card-title class="headline" style="color: #0f4898;"><strong>Delete User</strong></v-card-title>
                <v-card-text>Are you sure you want to delete this user?</v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn @click="dialogConfirm = false"
                    style="border-radius: 5px; border: 1px solid #000; background-color: transparent; color: #000;">
                    No</v-btn>
                  <v-btn @click="deleteItem"
                    style="border-radius: 5px; border: 1px solid #1976d2; background-color: transparent; color: #1976d2;">
                    OK</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
            <v-data-table :headers="headers" :items="userList" class="elevation-1" :search="searchAdmin"
              disable-initial-sort id="mytable">
              <template v-slot:items="props">
                <td class="text-left" style="font-size: 13px">
                  {{ props.item.email || '-' }}
                </td>
                <td class="text-xs-left" style="font-size: 13px">
                  {{ getMerchantNames(props.item.merchants) || '-' }}
                </td>
                <td class="justify-center layout px-0">
                  <v-icon small color="#0f4898" class="mr-2" @click="editItem(props.item.email, props.item.merchants)">
                    edit
                  </v-icon>
                  <v-icon small color="red" @click="dialogDel(props.item.email)">
                    delete
                  </v-icon>
                </td>
              </template>
            </v-data-table>
          </v-container>
        </v-card>
      </div>
    </v-flex>
  </v-layout>
</template>


<script>
import moment from 'moment'
import { sync } from 'vuex-pathify'
moment.locale('en')
export default {
  data() {
    return {
      dialog: false,
      dialog2: false,
      dialogConfirm: false,
      account_id: this.$cookies.get('account_id'),
      addMail: '',
      editMail: '',
      currentId: {},
      delelteEmail: '',
      searchAdmin: '',
      addMerchant: '',
      editMerchant: '',
      merchantStore: [],
      userList: [],
      mydropdown: ['Admin'],
      newEmail: "", // เพิ่มตัวแปรนี้เพื่อเก็บค่าอีเมลใหม่
      headers: [
        { text: 'E-mail', align: 'left', value: 'email' },
        { text: 'Merchant', align: 'left', value: 'merchant' },
        { text: 'Action', align: 'center', value: 'action', sortable: false }
      ],
      editedItem: {
        email: '',
        merchant: '',
      },
      defaultItem: {
        email: '',
        merchant: '',
      }
    }
  },
  methods: {
    clearForm() {
      Object.keys(this.form).forEach(f => {
        this.$refs[f].reset()
      })
    },
    async checkField() {
      this.formHasErrors = false
      Object.keys(this.form).forEach(f => {
        if (!this.form[f]) this.formHasErrors = true
        this.dialogloader = false
        this.$refs[f].validate(true)
      })
    },
    getMerchantNames(merchants) {
      if (!merchants || merchants.length === 0) return "-";
      return merchants.map((merchant) => merchant.merchantName).join(", ");
    },
    handleView() {
      this.mobileView = window.innerWidth <= 990
    },
    async getuser() {
      try {
        this.istableloading = true
        var { data } = await this.axios.get(`${process.env.VUE_APP_APIHOST}/user/all`, {
          headers: {
            Authorization: this.$cookies.get('token')
          }
        })
        this.userList = data.data

        // console.log(this.account_id)
        this.istableloading = false
      } catch (error) {
        this.istableloading = false
        console.log(error.message)
      }
    },
    editItem(email, merchants) {
      this.currentId = { email: email };
      this.newEmail = email;
      // this.merchantIds = this.props.merchants.map((merchant) => merchant.merchantId);

      const merchantID = merchants.map(item => item.merchantId);
      this.editMerchant = [...merchantID]; // ทำให้เป็นอาร์เรย์

      this.dialog2 = true;
    }

    ,

    async dialogDel(item) {
      this.delelteEmail = item
      this.dialogConfirm = true
      // console.log(this.delelteEmail)
    },
    async deleteItem() {
      this.istableloading = true
      // this.delelteEmail = item
      // confirm('Are you sure you want to delete this email?')
      // alert('Are you sure you want to delete this email?')
      let { data } = await this.axios.delete(`${process.env.VUE_APP_APIHOST}/user/delete`,
        {
          data: { email: this.delelteEmail }, // Ensure email is sent in the body
          headers: { Authorization: this.$cookies.get('token') }
        })
      window.location.reload()
      //  && this.userList.splice(index, 1)
    },
    close() {
      this.clearForm()
      this.dialog = false
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 300)
    },
    async fetchMerchants() {
      try {
        const { data } = await this.axios.get(`${process.env.VUE_APP_APIHOST}/merchants`, {
          headers: { Authorization: this.$cookies.get('token') }
        });

        this.merchantStore = data.data.map(item => ({
          merchant_name: item.merchant_name, // กำหนด key สำหรับแสดง
          merchant_id: item.merchant_id     // กำหนด key สำหรับส่งค่า
        }));

      } catch (error) {
        console.error('Error fetching merchants:', error);
        alert('Error fetching merchants data.');
      }
    },
    async save() {
      this.istableloading = true;

      // ตรวจสอบว่าฟอร์มไม่มีข้อผิดพลาด
      if (!this.formHasErrors) {
        try {
          // แปลง addMerchant ให้เป็นรูปแบบสตริงที่ต้องการ
          const formattedMerchantIds = `['${this.addMerchant.join("','")}']`;

          // ส่งคำขอ POST ไปยัง API
          const response = await this.axios.post(
            `${process.env.VUE_APP_APIHOST}/user/register`,
            {
              email: this.addMail,
              merchantIds: formattedMerchantIds, // ใช้ค่าที่แปลงแล้ว
              createdBy: this.$cookies.get('firstname') // ส่งข้อมูลผู้สร้าง
            },
            {
              headers: { Authorization: this.$cookies.get('token') } // ส่ง header token
            }
          );

          // ตรวจสอบสถานะการตอบกลับจาก API
          if (response && response.data && response.data.success) {
            // ถ้าสำเร็จ ให้รีเฟรชหน้า
          }

          window.location.reload();

        } catch (error) {
          // แสดงข้อผิดพลาดถ้าเกิดข้อผิดพลาดในการเชื่อมต่อ API
          console.error(error);
          alert('An error occurred while saving.'); // แจ้งเตือนข้อผิดพลาดจากการเชื่อมต่อ
        }
      } else {
        alert('Please fill out all required fields.');
      }
    },

    async edit() {
      this.istableloading = true;
      try {
        // Send the PUT request to update the user's data
        let { data } = await this.axios.put(`${process.env.VUE_APP_APIHOST}/user/edit`, {
          email: this.currentId.email,  // Original email (to find the user)
          newEmail: this.newEmail,      // Updated email
          merchantIds: this.editMerchant || [], // ตรวจสอบว่าค่าถูกต้อง
          createdBy: this.$cookies.get('firstname')
        }, {
          headers: { Authorization: this.$cookies.get('token') }
        });

        if (data.success) {
          // If update is successful, reload the page or close dialog
          window.location.reload();
        }
        window.location.reload();

      } catch (error) {
        console.error(error);
        alert('An error occurred while updating the user.');
      } finally {
        this.istableloading = false;
      }
    }
  },
  created() {
    this.getuser()
    this.fetchMerchants(); // ดึงข้อมูล merchants
    if (this.editMerchant && this.editMerchant.length > 0) {
      this.editMerchant = this.editMerchant;
    } this.handleView()
    window.addEventListener('resize', this.handleView)
  },
  computed: {
    form() {
      return {
        addmail: this.addMail,
        addmerchant: this.addMerchant,
      }
    }
  },
  watch: {
    dialog(val) {
      val || this.close()
    }
  }
}
</script>